// CSV for downloads that people open in Excel.
//
//   toCsv(rows, [{ label, get: (row) => value }])  → the file text, header row first
//   csvCell(value)                                  → one cell, quoted when it has to be

// A text cell that starts with = + - @ or a tab / carriage return is a formula to Excel, so it gets
// a leading apostrophe and opens as text. Numbers, negative ones included, are left as numbers.
const FORMULA_START = /^[=+\-@\t\r]/;
const NUMBER = /^-?\d+(\.\d+)?$/;

export function csvCell(v) {
  let s = v == null ? '' : String(v);
  if (typeof v !== 'number' && FORMULA_START.test(s) && !NUMBER.test(s)) s = `'${s}`;
  // A carriage return starts a new row in Excel too, so a cell holding one is quoted; otherwise the
  // text after it (perhaps "=cmd") would open as a cell of its own, outside the apostrophe guard.
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv(rows, cols) {
  return [cols.map((c) => csvCell(c.label)).join(','),
    ...(rows || []).map((r) => cols.map((c) => csvCell(c.get(r))).join(','))].join('\n');
}
